import { withStyles } from '@material-ui/styles';
import React, { useMemo, useState } from 'react'
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import withErrorCatcher from '../../../Common/withErrorCatcher';
import PrivacyPolicy from '../../../Common/privacyPolicy';
import { Typography } from '@material-ui/core';
import { UpgradePlan } from '../../../Common/Subscription/UpgradePlan/UpgradePlan';
import { push } from 'react-router-redux';
import './footer.css'

const _LeftDrawerFooter = (props) => {
    const {t, subscriptionType, dispatch} = props
    const [openDialogPrivacy, setOpenDialogPrivacy] = useState(false)

    const allowUnlockBusinessClass = useMemo(() => {
        if([1].includes(subscriptionType)) return true
        return false
    }, [subscriptionType])

    const onClosePrivacyDialog = () => {
        setOpenDialogPrivacy(false)
    }

    // const onOpenPrivacyDialog = () => {
        // setOpenDialogPrivacy(true)
    // }

    const onClickTuqqiCom = () => {
        window.open('https://tuqqi.com', '_blank')
    }

    const openSubscriptionDialog = () => {
        dispatch(push('/admin/billing'))
    }

    const Upgrade = allowUnlockBusinessClass && <UpgradePlan subscriptionType={subscriptionType} onClick={openSubscriptionDialog}/>

    const PrivacyPolicyItem = openDialogPrivacy ? 
        <PrivacyPolicy
            open={openDialogPrivacy}
            close={onClosePrivacyDialog}
        /> : 
        <div data-intrcm-id="LeftDrawerFooter_pi4vypsq" />

    const Terms = <Typography variant="div" gutterBottom align="left" className='terms-footer'>
        {/* <span onClick={onOpenPrivacyDialog}>{t('Terms')}</span> · <span className='tuqqiCom-footer' onClick={onClickTuqqiCom}>Tuqqi.com</span>  · v{process.env.CURRENT_VERSION} */}
        <span className='tuqqiCom-footer' onClick={onClickTuqqiCom}>Tuqqi.com</span>  · v{process.env.CURRENT_VERSION}
    </Typography>

    const TuqqiUpToDate = <Typography variant="div" gutterBottom align="left" className='terms-sub-footer'>
        Tuqqi © 2023
    </Typography>

    return <>
        {Upgrade}
        <div data-intrcm-id="LeftDrawerFooter_a9ksp0aa" className='listItem-footer'>
            {PrivacyPolicyItem}
            {Terms}
            {TuqqiUpToDate}
        </div>
    </>
}

const mapStateToProps = (state) => ({
    subscriptionType: state.globalData.currentSubscription.subscriptionType,
})

const mapDispatchToProps = dispatch => ({dispatch})

export default compose(
    withErrorCatcher(),
    withTranslation('drawerListItemTerms'),
    connect(mapStateToProps, mapDispatchToProps)
)(_LeftDrawerFooter);